export default __webpack_public_path__ + "static/media/problema-04.00b5dd6c.webp";